import { useLayoutEffect } from 'react';
import { Outlet } from 'react-router';
import oldAdminCssUrl from '../../scss/app.scss?url';
import { applyCssIfChanged } from './cssUtils';

export function oldAdminLoader() {
    window.__LAYOUT_CSS__ = [oldAdminCssUrl];
    return null;
}

export const OldAdminScss = () => {
    useLayoutEffect(() => {
        applyCssIfChanged([oldAdminCssUrl]);
    }, []);
    return <Outlet />;
};
